import ChatService from '~/pages/chat/chat.service';

export default class {
	/* @ngInject */
	constructor($rootScope, chatService) {
		$rootScope.$on('socket:ready', (event, socket) => {
			this.socket = socket;
		});

		/** @type {ChatService} */
		this.chatService = chatService;

		this.message = '';
		this.from = '';
		this.room = 'KCHATROOM;0000045M2Z1GQ68C00';
	}

	sendMessage() {
		this.chatService.send({
			text: this.message,
			file: null,
			isEditing: false,
			isReplying: false,
			room: this.room,
			from: this.from,
		});
	}

	getRooms() {
		return [...this.chatService.rooms];
	}
}
